module.exports = __webpack_public_path__ + "img/Unidad5-1.afa06220.png";